module.exports = __webpack_public_path__ + "img/taali_wa_gaali_notification-winners.4cc8e597.png";